<template>
  <el-form :model="data" class="activity-review">
    <div class="activity-review__info">
      <review-info-box
        :rfq-type="dataSourceRfqType.map[data.rfqTypeID] && dataSourceRfqType.map[data.rfqTypeID].title"
        :company="data.customerCompanyName"
        :po="data.po"
        :partNumber="data.partNumber"
        :partSN="data.partSN"
        :baxPO="data.baxpo"
        :supplierCompanyName="data.supplierCompanyName"
      />
    </div>
    <div class="activity-review__boxes">
      <div class="row mx-0">
        <div class="col-xl-2 col-md-4 col-6">
          <div class="activity-review__box">
            <el-form-item
              :label="L10n('order-phase')"
              prop="orderPhase"
              class="material-style"
            >
              <select-response
                :model.sync="form.orderPhaseID"
                @on-change="autoSaveField('orderPhaseID')"
                :isLoading="dataSourceOrderPhase.loading"
                :data="dataSourceOrderPhase.records"
              ></select-response>
            </el-form-item>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-6">
          <div class="activity-review__box">
            <el-form-item
              :label="L10n('phase-date')"
              prop="phaseDate"
              class="material-style"
            >
              <date-picker
                v-model="form.phaseDate"
                @change="autoSaveField('phaseDate')"
              ></date-picker>
            </el-form-item>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-6">
          <div class="activity-review__box">
            <el-form-item
              :label="L10n('phase-employee')"
              prop="phasePersonInChargeEmployeeID"
              class="material-style"
            >
              <select-response
                :model.sync="form.phasePersonInChargeEmployeeID"
                @on-change="autoSaveField('phasePersonInChargeEmployeeID')"
                :isLoading="dataSourceEmployee.loading"
                :data="dataSourceEmployee.records"
              ></select-response>
            </el-form-item>
          </div>
        </div>
        <div class="col-xl-4 col-md-4 col-6">
          <div class="activity-review__box" :class="classStandBy">
            <el-form-item
              :label="L10n('stand-by')"
              prop="standby"
              class="material-style mr-1"
            >
              <select-response
                :model.sync="form.standby"
                :data="sourceStandBy"
                @on-change="(id, data) => autoSaveField('standby', { label: data && data.title, payloadData: { standbyDate: new Date() }})"
              >
              </select-response>
            </el-form-item>
            <el-form-item
              :label="L10n('stand-by-date')"
              prop="standbyDate"
              class="material-style"
            >
              <date-picker
                v-model="form.standbyDate"
                @change="autoSaveField('standbyDate')"
              >
              </date-picker>
            </el-form-item>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-6">
          <div class="activity-review__box" :class="classConfirmedEdd">
            <el-form-item
              :label="L10n('confirmed-edd')"
              class="material-style"
            >
              <date-picker
                v-model="form.estimatedDeliveryDate"
                @change="autoSaveField('estimatedDeliveryDate', { api: `RFQ2s/Patch/${form.rfq2ID}` })"
              >
              </date-picker>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
    <div class="activity-review__control">
      <ui-button
        style="height: 100%"
        class="btn btn-size-s"
        :label="L10n('details')"
        isVertical
        @click="$emit('onDetails')"
      />
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'ActivityReviewForm',
  mixins: [Form],
  components: {
    'review-info-box': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Activity/ReviewInfoBox')
  },
  computed: {
    dataSourceOrderPhase () {
      return this.API('OrderPhases/GetAllDynamic?select=id,title&filter=!title.startsWith("Z_")&orderBy=title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    sourceStandBy () {
      return [
        { id: 'sourcing-parts', title: this.L10n('sourcing-parts') },
        { id: 'standby', title: this.L10n('standby') },
        { id: 'pending-payment', title: this.L10n('pending-payment') }
      ]
    },
    classStandBy () {
      return {
        'bg-orange': this.form.standbyDate
      }
    },
    classConfirmedEdd () {
      if (!this.form.estimatedDeliveryDate) {
        return 'bg-red'
      } else {
        return 'bg-green'
      }
    }
  }
}
</script>
